/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';

import { createRoute } from '@gh/common-shared';

import { MilestoneEventDetailsComponent } from './components/milestone-event-details/milestone-event-details.component';
import { MilestoneEventListComponent } from './components/milestone-event-list/milestone-event-list.component';
import { MilestoneEventDetailsBusinessService } from './resources/milestone-event-details-business.service';
import { MilestoneEventListBusinessService } from './resources/milestone-event-list-business.service';

const routes = [
  createRoute({
    component: MilestoneEventListComponent,
    path: '',
    init: MilestoneEventListBusinessService,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: ['Setup.MilestoneEvents.LIST'],
    },
  }),
  createRoute({
    component: MilestoneEventDetailsComponent,
    path: 'new',
    init: MilestoneEventDetailsBusinessService,
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: ['Setup.MilestoneEvents.CREATE'],
    },
  }),
  createRoute({
    component: MilestoneEventDetailsComponent,
    path: ':milestoneEventId',
    init: MilestoneEventDetailsBusinessService,
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: ['Setup.MilestoneEvents.EDIT', 'Setup.MilestoneEvents.VIEW'],
    },
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupMilestoneEventsRoutingModule {
}
